<template>
  <div id="app">
    <router-view  v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  provide(){
      return{
          reload:this.reload
      }
  },
  data(){
      return {
          isRouterAlive:true,
      }
  },
  mounted(){
    //var  url=location.href;
    //if (url.indexOf("/mobile/")<0 && this._isMobile()) {
      // 手机端
    //  this.$router.replace("/mobile");
    //} else if (url.indexOf("/mobile/")>0){
      // pc端
    //  this.$router.replace("/");
    //}
},
  methods:{
  reload(){
          this.isRouterAlive = false;
          this.$nextTick(function () {
                var  editableTab = TagsView.editableTab;
                let flag = false;
                let tabs = editableTab.editableTabs;
                tabs.forEach((tab, index) => {
                  if (tab.name == this.$route.name) {
                    flag = true;
                  }
                });
               //修改tagsview
               if(!flag){
                 editableTab.editableTabs.push({
                    title: this.$route.name,
                    name:  this.$route.name,
                    content:this.$route.path,
                    route:this.$route
                  });
               }
                editableTab.editableTabsValue =  this.$route.name;
                this.isRouterAlive = true
            });
      },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
      );
      return flag;
    },
  },
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// App.vue?c7b088f6